import { css } from 'styled-components';

export const StyledAdminUsersRowsWidth = css`
  &:not(.comment) {
    flex-grow: 0;
    flex-basis: initial;
  }

  &.id {
    width: 5.6rem;
  }

  &.email {
    width: 14.2rem;
  }

  &.cost {
    width: 12.8rem;
  }

  &.adjust {
    width: 12.8rem;
  }

  &.link {
    width: 9.2rem;
  }

  &.wallet {
    width: 14.4rem;
  }

  &.vip {
    width: 6.4rem;
  }

  &.averagedailyhashrate {
    width: 17.2rem;
  }

  &.averageweeklyhashrate {
    width: 17.2rem;
  }

  &.createdat {
    width: 16.4rem;
  }

  &.updatedat {
    width: 16.4rem;
  }

  &.comment {
    flex-grow: 1;
  }
`;
